import React, { useState, useContext, useCallback, useEffect } from "react";
import { Theme, makeStyles } from "@material-ui/core/styles";
import {
  Grid,
  Paper,
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TablePagination,
  Typography,
  TableRow,
  TableCell,
} from "@material-ui/core";
import UserHeaderTable from "../../components/user-table/user-headertable";
import UserRowTable from "../../components/user-table/user-rowtable";
import { LangContext } from "../../context/lang";
import { getUserList, getUpdateUser, deleteUser } from "../../apis/user";
import { useSnackbar } from "notistack";
import ConfirmDelete from "../../components/confirm-delete";

const useStyle = makeStyles((theme: Theme) => ({
  root: {
    height: `calc(100% - ${theme.spacing(4)}px)`,
    width: `calc(100% - ${theme.spacing(4)}px)`,
    padding: theme.spacing(2),
  },
  btn: { textTransform: "unset" },
  paper: {
    padding: 0,
  },
  primary: { fontFamily: ["Montserrat-Medium", "Kanit-Medium"].join(",") },
  tableContainer: {
    height: `calc(100vh - ${theme.spacing(23)}px)`,
  },
  flexMiddle: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },
  flexCenter: { display: "flex", justifyContent: "center" },
}));

const User = () => {
  const classes = useStyle();
  const { enqueueSnackbar } = useSnackbar();
  const [stateData, setstateData] = useState([]);
  const [mockData, setmockData] = useState([]);
  const [page, setPage] = React.useState<number>(0);
  const [rowsPerPage, setRowsPerPage] = React.useState<number>(10);
  const [openDelete, setopenDelete] = useState<string | undefined>(undefined);
  const { lang } = useContext(LangContext);
  const [process, setprocess] = useState<boolean>(false);

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  const initUser = useCallback(async () => {
    const userlist = await getUserList();
    if (userlist.data) {
      const dontgetadmin = userlist.data.filter((rs: any) => {
        return rs.role !== "root" && rs.role !== "admin";
      });
      setstateData(dontgetadmin);
      setmockData(dontgetadmin);
    } else {
    }
  }, []);

  useEffect(() => {
    initUser();
    return () => {};
  }, [initUser]);

  const onEnabled = async (id: any, check: boolean) => {
    let udata = [...stateData];
    let item = {
      enabled: true,
    };
    let index = udata
      .map((rs: any) => {
        return rs._id;
      })
      .indexOf(id);
    item = udata[index];
    item.enabled = check;
    setstateData(udata);

    const update = await getUpdateUser(id, item);
    if (update.status.code === 200) {
      if (check) {
        enqueueSnackbar("Enabled user.", {
          variant: "success",
        });
      } else {
        enqueueSnackbar("Disabled user.", {
          variant: "success",
        });
      }
    } else {
      enqueueSnackbar("มีบางอย่างผิดพลาด", {
        variant: "error",
      });
    }
  };

  const _onAccept = async () => {
    setprocess(true);
    const rsDeluser: any = await deleteUser(openDelete ? openDelete : "");
    if (rsDeluser?.status === 204) {
      const uList: any = await getUserList();
      if (uList?.data) {
        setstateData(uList.data);
      } else {
        setstateData([]);
      }
      enqueueSnackbar("Deleted user.", { variant: "success" });
    } else {
      enqueueSnackbar("Oops, something went wrong", { variant: "error" });
    }
    setprocess(false);
    setopenDelete(undefined);
  };

  return (
    <div className={classes.root}>
      <ConfirmDelete
        open={Boolean(openDelete)}
        onClose
        cancel={() => {
          setopenDelete(undefined);
        }}
        accept={_onAccept}
        process={process}
      />
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Paper elevation={2} className={classes.paper}>
            <TableContainer className={classes.tableContainer}>
              <Table stickyHeader aria-label="simple table">
                <TableHead>
                  <UserHeaderTable
                    setStateData={setstateData}
                    mockData={mockData}
                    setPage={setPage}
                  />
                </TableHead>
                {stateData.length ? (
                  <TableBody>
                    {stateData
                      .slice(
                        page * rowsPerPage,
                        page * rowsPerPage + rowsPerPage
                      )
                      .map((row: any) => (
                        <UserRowTable
                          key={row._id}
                          data={row}
                          onEnabled={onEnabled}
                          clickDelete={(id: string) => {
                            setopenDelete(id);
                          }}
                        />
                      ))}
                  </TableBody>
                ) : (
                  <TableBody>
                    <TableRow>
                      <TableCell colSpan={5} style={{ height: "40rem" }}>
                        <Typography align="center">ไม่พบข้อมูล</Typography>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
            <TablePagination
              rowsPerPageOptions={[10, 25, 50]}
              labelRowsPerPage={lang.data.rowPerPage}
              component="div"
              count={stateData.length}
              rowsPerPage={rowsPerPage}
              page={page}
              onChangePage={handleChangePage}
              onChangeRowsPerPage={handleChangeRowsPerPage}
            />
          </Paper>
        </Grid>
      </Grid>
    </div>
  );
};

export default User;
